import React from 'react';
import { useIntl } from 'umi';
import DataSourceSelector from '@intelligence/components/TeaSelector/AnnieSource';
import { getStringArrayValue } from '../shared/valueUtils';
import { renderOptionSummary } from '../previewHelpers';
import { FILTER_TYPE } from '../filterTypes';

import type { IFilterRenderProps, IFilterTypeEntry } from '@intelligence/v3/filterCore/registry';
import type { IFilterControlModule, IFilterPreviewContext } from '../controlModule';
import type { IDataSourceFilterValue } from './types';

interface IDataSourceRendererProps<T> extends IFilterRenderProps<T> {
  showDatabrain?: boolean;
}

const DataSourceRenderer: React.FC<IDataSourceRendererProps<IDataSourceFilterValue>> = (props) => {
  const { field, showDatabrain = false, value, onChange, ...rest } = props;

  return (
    <DataSourceSelector
      {...rest}
      key={field}
      showDatabrain={showDatabrain}
      value={getStringArrayValue(value)}
      onConfirm={(payload: string[]) => {
        onChange(payload);
      }}
    />
  );
};

const DataSourcePreview: React.FC<{
  valueItem: any;
  dataSourceOptions: any[];
}> = (props) => {
  const { valueItem, dataSourceOptions } = props;
  const { locale, formatMessage } = useIntl();

  return (
    <>
      <span className="model-form-text">{formatMessage({ id: 'dbi_source' })}</span>
      <span className="model-form-context">{renderOptionSummary(valueItem, dataSourceOptions, formatMessage, locale)}</span>
    </>
  );
};

const getRenderPreview = (ctx: IFilterPreviewContext): NonNullable<IFilterTypeEntry['renderPreview']> => {
  const { dataSourceOptions = [] } = ctx;

  // eslint-disable-next-line react/display-name
  function renderDataSourcePreview(
    _item: Parameters<NonNullable<IFilterTypeEntry['renderPreview']>>[0],
    value: any,
  ): React.ReactNode {
    return <DataSourcePreview valueItem={value} dataSourceOptions={dataSourceOptions} />;
  }

  return renderDataSourcePreview;
};

export const dataSourceControl: IFilterControlModule = {
  type: FILTER_TYPE.DATA_SOURCE,
  entry: {
    render: (props) => {
      return <DataSourceRenderer {...props} />;
    },
  },
  getRenderPreview,
};
